export default "__VITE_ASSET__692639ae__"